import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Manager, Target, Popper } from "react-popper";

import update from 'immutability-helper';
import moment from 'moment'

// material-ui components
import withStyles from "material-ui/styles/withStyles";
import MenuItem from "material-ui/Menu/MenuItem";
import MenuList from "material-ui/Menu/MenuList";
import ClickAwayListener from "material-ui/utils/ClickAwayListener";
import Paper from "material-ui/Paper";
import Grow from "material-ui/transitions/Grow";
import IconButton from "material-ui/IconButton";
import Hidden from "material-ui/Hidden";

// @material-ui/icons
import Person from "@material-ui/icons/Person";
import Notifications from "@material-ui/icons/Notifications";
import Dashboard from "@material-ui/icons/Dashboard";
import Search from "@material-ui/icons/Search";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";

// core components
import GridContainer from "../Grid/GridContainer";
import ItemGrid from "../Grid/ItemGrid";
import CustomInput from "../CustomInput/CustomInput.jsx";
import SearchButton from "../CustomButtons/IconButton.jsx";

import headerLinksStyle from "assets/jss/material-dashboard-pro-react/components/headerLinksStyle";

import { client } from "client";
import { getNotificationCount, getNotifications, updateNotificationStatus } from 'views/notifications/graph';
import Loading from "views/etc/Loading";


class HeaderLinks extends React.Component {
  state = {
    open: false,
    notifCount: 0,
    isLoading: false,
    page: 0,
    hasNext: false,
    hasPrev: false,
    pages: 0,
    notifs: []
  };

  handleClick = () => {
    this.setState({ open: !this.state.open, isLoading: true });

    this.fetchData();
  };
  handleClose = () => {
    this.setState({ open: false });
  };

  checkRoutes(route) {
    for (const i in this.props.routes) {
      const r = `/${route}`;
      if (r === this.props.routes[i].path) {
        this.props.history.push(r);
        break;
      }
    }
  }

  onNotifItemClick = (item) => {
    if (item['action'] !== 'none') {
      this.checkRoutes(item['action']);
    }

    if (item['getStatus'] === 'sent') {
      client.mutate({
          mutation: updateNotificationStatus,
          variables: ({
            notifPk: parseInt(item['notifPk']),
            status: 2 //2 = read
          }),
          fetchPolicy: "no-cache"
      }).then((data) => {
        let notifs = this.state.notifs;
        let c = this.state.notifCount;

        let newNotifs = notifs.map((row, i) => {
            for (const key in row) {
                if (key === 'getStatus' && row.notifPk === item.notifPk) {
                    row = update(row, {getStatus: {$set: 'read'}});

                    if (c != 0)
                      c--;
                }
            }
            return row;
        });

        this.setState({notifs: newNotifs, notifCount: c});
      });
    }
  }

  fetchData() {
    let page = this.state.page;

    client.query({
      query: getNotifications,
      variables: {
        filterBy: JSON.stringify([]),
        offset: page, 
        pageSize: 15,
        sort: JSON.stringify([]),
        uid: localStorage.getItem('APN_USERID')
      },
      fetchPolicy: "network-only"
    }).then((data) => {
      this.setState({
          notifs: data.data.notifications.notifications, 
          isLoading: false, 
          pages: data.data.notifications.pages, 
          hasNext: data.data.notifications.hasNext, 
          hasPrev: data.data.notifications.hasPrev
      });
    });
  }

  componentWillMount() {
    client.mutate({
        mutation: getNotificationCount,
        variables: ({uid: localStorage.getItem('APN_USERID')}),
        fetchPolicy: "no-cache"
    }).then((data) => {
      this.setState({notifCount: data.data.notificationCount.count});
    });
  }

  onNextBtnClick() {
    let page = this.state.page;
    page++;

    this.state.page = page;


    this.setState({page: page, isLoading: true});
    this.fetchData();
  }

  onPrevBtnClick() {
    let page = this.state.page;

    page--;

    this.state.page = page;
    this.setState({page: page, isLoading: true});
    this.fetchData();
  }

  render() {
    const { classes, rtlActive, newNotifCount } = this.props;
    const { open, notifCount, isLoading, hasNext, hasPrev, notifs } = this.state;
    const searchButton =
      classes.top +
      " " +
      classes.searchButton +
      " " +
      classNames({
        [classes.searchRTL]: rtlActive
      });
    const dropdownItem =
      classes.dropdownItem +
      " " +
      classNames({
        [classes.dropdownItemRTL]: rtlActive
      });
    const wrapper = classNames({
      [classes.wrapperRTL]: rtlActive
    });
    const managerClasses = classNames({
      [classes.managerClasses]: true
    });


    let notifList = null;
    let notifNavCount = null;

    if (isLoading) {
      notifList = (<Loading />);
    }
    else {
      notifList = [];
      if (notifs) {
        for (const i in notifs) {
          let isNew = null;
          const d = notifs[i].timeSent;
          const dM = moment(d).format('YYYY-MM-DD h:mm:ss a');

          if (notifs[i].getStatus == 'sent')
            isNew = (<span className={classes.notifications} style={{'right': '0', 'height': '11px', 'minWidth': '11px'}}/>);

          notifList.push(<MenuItem
                    onClick={() => {this.onNotifItemClick(notifs[i])}}
                    className={dropdownItem}
                    key={`${notifs[i].notifPk}-notif`}
                  >
                    {isNew}
                    {`${notifs[i].title} - ${notifs[i].message} (${dM})`}
                  </MenuItem>);
        }
      }
    }

    if (notifCount > 0 || newNotifCount > 0) {
      let cc = notifCount + newNotifCount;
      notifNavCount = (<span className={classes.notifications}>{cc}</span>);
    }


    return (
      <div className={wrapper}>
        <Manager className={managerClasses}>
          <Target>
            <IconButton
              color="inherit"
              aria-label="Notifications"
              aria-owns={open ? "menu-list" : null}
              aria-haspopup="true"
              onClick={this.handleClick}
              className={rtlActive ? classes.buttonLinkRTL:classes.buttonLink}
              classes={{
                label: rtlActive ? classes.labelRTL:""
              }}
            >
              <Notifications className={rtlActive ? classes.links + " " + classes.linksRTL:classes.links} />
              {notifNavCount}
              <Hidden mdUp>
                <p onClick={this.handleClick} className={classes.linkText}>
                  {rtlActive ? "إعلام" : "Notification"}
                </p>
              </Hidden>
            </IconButton>
          </Target>
          <Popper
            placement="bottom-start"
            eventsEnabled={open}
            className={
              classNames({ [classes.popperClose]: !open }) +
              " " +
              classes.pooperResponsive
            }
          >
            <ClickAwayListener onClickAway={this.handleClose}>
              <Grow
                in={open}
                id="menu-list"
                style={{ transformOrigin: "0 0 0" }}
              >
                <Paper className={classes.dropdown}>
                  <MenuList role="menu">
                    {notifList}
                  </MenuList>

                  <GridContainer direction="row" align="center">
                    <ItemGrid xs={6}>
                      <SearchButton
                          color="defaultNoBackground"
                          disabled={!hasPrev}
                          onClick={this.onPrevBtnClick.bind(this)}>
                          <KeyboardArrowLeftIcon />
                      </SearchButton>
                    </ItemGrid>
                    <ItemGrid xs={6}>
                      <SearchButton
                          color="defaultNoBackground"
                          disabled={!hasNext}
                          onClick={this.onNextBtnClick.bind(this)}>
                          <KeyboardArrowRightIcon />
                      </SearchButton>
                    </ItemGrid>
                  </GridContainer>
                </Paper>
              </Grow>
            </ClickAwayListener>
          </Popper>
        </Manager>
        <IconButton
          color="inherit"
          aria-label="Person"
          className={rtlActive ? classes.buttonLinkRTL:classes.buttonLink}
          classes={{
            label: rtlActive ? classes.labelRTL:""
          }}
        >
          <Person className={rtlActive ? classes.links + " " + classes.linksRTL:classes.links} />
          <Hidden mdUp>
            <p className={classes.linkText}>
              {rtlActive ? "الملف الشخصي" : "Profile"}
            </p>
          </Hidden>
        </IconButton>
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  rtlActive: PropTypes.bool
};

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx